import styled from "@emotion/styled";

export const StyledContactMessage = styled.div`
  &.contact-chip-card {
    background: var(--bg);
    border: 1px solid var(--border);
    border-radius: 16px;
    padding: 14px 16px;
    max-width: 420px;
    box-shadow: 0 2px 10px rgba(30, 41, 59, 0.06);
  }

  .top-row {
    display: flex;
    align-items: center;
  }

  .avatar-stack {
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }

  .avatar-stack .ant-avatar {
    border: 2px solid var(--bg);
    box-shadow: 0 0 0 1px var(--border);
  }

  .avatar-stack .ant-avatar:not(:first-of-type) {
    margin-left: -14px;
  }

  .text-col {
    flex: 1;
    margin: 0 12px;
    min-width: 0;
  }

  .headline {
    font-size: 15px;
    font-weight: 600;
    color: var(--primary);
    line-height: 1.35;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .divider {
    height: 1px;
    background: var(--border);
    margin: 12px 0;
    border: none;
  }

  .view-all-btn {
    width: 100%;
    display: flex;
    justify-content: center;
    font-weight: 600;
    color: var(--primary);
  }
`;
